module.exports = __webpack_public_path__ + "static/media/WilsonTsai@2x.b22e837f.png";